const ConfirmationModal = ({ display, confirmAction, confirmText, denyAction, denyText='Cancel', title, children }) => (
    <div className={`modal ${display ? 'is-active' : ''}`}>
        <div className="modal-background"></div>
        <div className="modal-card">
            <header className="modal-card-head">
                <p className="modal-card-title" style={{ textAlign: 'left' }}>{title}</p>
            </header>
            <section className="modal-card-body" style={{ textAlign: 'left' }}>{children}</section>
            <footer className="modal-card-foot">
                <button className="button is-info" onClick={confirmAction} type='button'>
                    {confirmText}
                </button>
                <button className="button" onClick={denyAction} type='button'>
                    {denyText}
                </button>
            </footer>
        </div>
    </div>
)

export default ConfirmationModal